export default __webpack_public_path__ + "static/media/calendar-ES.5a98df25.png";